/**
 * Common types used across the application
 */
// Helper functions for working with EpochTimeStamp
export const EpochTimeStampUtils = {
    // Convert Date to EpochTimeStamp
    fromDate: (date) => date.getTime(),
    // Convert EpochTimeStamp to Date
    toDate: (timestamp) => new Date(timestamp),
    // Get current timestamp
    now: () => Date.now(),
    // Convert ISO string to EpochTimeStamp
    fromISOString: (isoString) => new Date(isoString).getTime(),
    // Convert EpochTimeStamp to ISO string
    toISOString: (timestamp) => new Date(timestamp).toISOString(),
    // Format EpochTimeStamp for date input (YYYY-MM-DD)
    toDateInputFormat: (timestamp) => {
        // Use UTC components to avoid off-by-one due to local timezone
        const date = new Date(timestamp);
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, "0");
        const day = String(date.getUTCDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    },
    // Parse date input format (YYYY-MM-DD) to EpochTimeStamp
    fromDateInputFormat: (dateString) => {
        return new Date(`${dateString}T00:00:00.000Z`).getTime();
    },
    // Format EpochTimeStamp for display
    toDisplayFormat: (timestamp, locale = "en-US") => {
        return new Date(timestamp).toLocaleDateString(locale);
    },
    // Check if timestamp is valid
    isValid: (timestamp) => {
        return !Number.isNaN(timestamp) && timestamp > 0;
    },
};
//# sourceMappingURL=Common.js.map